import { useParams, Link } from 'react-router-dom';
import SEO from '@/components/feature/SEO';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { getArticleBySlug, getRelatedArticles } from '@/mocks/articles';

const detailImages: Record<string, string> = {
  'xinshou-ru-men-gonglue': 'https://readdy.ai/api/search-image?query=Anime%20style%20fantasy%20adventure%20starting%20village%20with%20cute%20new%20adventurers%2C%20warm%20welcoming%20atmosphere%2C%20soft%20pastel%20colors%2C%20gentle%20sunlight%2C%20cherry%20blossom%20trees&width=1200&height=600&seq=detail-xinshou&orientation=landscape',
  'shenmi-daoju-zhong-sheng-zhi-mi': 'https://readdy.ai/api/search-image?query=Anime%20style%20mysterious%20ancient%20ritual%20circle%20with%20glowing%20magic%20energy%2C%20ethereal%20blue%20and%20pink%20light%2C%20fantasy%20atmosphere%2C%20sparkling%20particles&width=1200&height=600&seq=detail-zhongsheng&orientation=landscape',
  'renqi-juese-xiaoying-xiangjie': 'https://readdy.ai/api/search-image?query=Anime%20style%20beautiful%20healer%20girl%20with%20pink%20hair%20surrounded%20by%20cherry%20blossom%20petals%2C%20magical%20healing%20aura%2C%20soft%20warm%20lighting%2C%20gentle%20smile&width=1200&height=600&seq=detail-xiaoying&orientation=landscape',
  'xinghu-yiji-tanxian-riji': 'https://readdy.ai/api/search-image?query=Anime%20style%20ancient%20starry%20ruins%20reflected%20in%20crystal%20clear%20lake%2C%20mysterious%20glowing%20crystals%2C%20adventure%20party%2C%20fantasy%20atmosphere&width=1200&height=600&seq=detail-xinghu&orientation=landscape',
  'qihuan-shijie-sheding-quanjie': 'https://readdy.ai/api/search-image?query=Anime%20style%20fantasy%20world%20with%20floating%20islands%20and%20constellations%2C%20ancient%20magic%20tomes%2C%20seven%20elemental%20orbs%2C%20mystical%20atmosphere&width=1200&height=600&seq=detail-shijieguan&orientation=landscape',
  'gaojie-zhandou-jiqiao': 'https://readdy.ai/api/search-image?query=Anime%20style%20epic%20battle%20scene%20with%20cute%20characters%20fighting%20dragon%2C%20dynamic%20action%2C%20magic%20effects%2C%20soft%20pastel%20colors&width=1200&height=600&seq=detail-zhandou&orientation=landscape',
  'an-ying-senlin-mi-mi': 'https://readdy.ai/api/search-image?query=Anime%20style%20dark%20enchanted%20forest%20with%20soft%20glowing%20spirits%2C%20mysterious%20ancient%20altar%2C%20moonlight%2C%20ethereal%20atmosphere&width=1200&height=600&seq=detail-anying&orientation=landscape',
  'quan-juese-shou-cang-zhi-nan': 'https://readdy.ai/api/search-image?query=Anime%20style%20group%20of%20cute%20diverse%20adventurer%20characters%20posing%20together%2C%20colorful%20designs%2C%20cheerful%20atmosphere%2C%20pastel%20colors&width=1200&height=600&seq=detail-jiaose&orientation=landscape',
  'jingyan-jiasu-shengji-jiqiao': 'https://readdy.ai/api/search-image?query=Anime%20style%20character%20powering%20up%20with%20golden%20glowing%20energy%20aura%2C%20leveling%20up%20effect%2C%20determined%20expression%2C%20fantasy%20training%20ground&width=1200&height=600&seq=detail-shengji&orientation=landscape',
  'huoban-qianghua-jiban-zhinan': 'https://readdy.ai/api/search-image?query=Anime%20style%20heartwarming%20friendship%20moment%20between%20cute%20characters%2C%20sparkling%20magical%20bond%2C%20cherry%20blossom%20garden%2C%20soft%20lighting&width=1200&height=600&seq=detail-jiban&orientation=landscape',
  'daoju-cangku-guanli-jiqiao': 'https://readdy.ai/api/search-image?query=Anime%20style%20cozy%20organized%20magical%20storage%20room%20with%20potions%20scrolls%20and%20crystals%2C%20warm%20lighting%2C%20fantasy%20inventory&width=1200&height=600&seq=detail-cangku&orientation=landscape',
  'weilai-gengxin-yugao': 'https://readdy.ai/api/search-image?query=Anime%20style%20magnificent%20sky%20castle%20floating%20among%20clouds%2C%20golden%20sunrise%2C%20new%20adventure%20horizon%2C%20hopeful%20atmosphere&width=1200&height=600&seq=detail-gengxin&orientation=landscape',
};

const relatedImages: Record<string, string> = {
  'xinshou-ru-men-gonglue': 'https://readdy.ai/api/search-image?query=Anime%20style%20fantasy%20beginner%20guide%20thumbnail%2C%20cute%20characters%2C%20warm%20village%20scene%2C%20soft%20pastel&width=600&height=350&seq=rel-xinshou&orientation=landscape',
  'shenmi-daoju-zhong-sheng-zhi-mi': 'https://readdy.ai/api/search-image?query=Anime%20style%20mysterious%20ritual%20thumbnail%2C%20glowing%20magic%20circle%2C%20ethereal%20light%2C%20fantasy%20theme&width=600&height=350&seq=rel-zhongsheng&orientation=landscape',
  'renqi-juese-xiaoying-xiangjie': 'https://readdy.ai/api/search-image?query=Anime%20style%20cute%20healer%20girl%20thumbnail%2C%20cherry%20blossoms%2C%20gentle%20smile%2C%20soft%20pink%20tones&width=600&height=350&seq=rel-xiaoying&orientation=landscape',
  'xinghu-yiji-tanxian-riji': 'https://readdy.ai/api/search-image?query=Anime%20style%20ruins%20exploration%20thumbnail%2C%20starry%20lake%2C%20adventure%2C%20mysterious%20atmosphere&width=600&height=350&seq=rel-xinghu&orientation=landscape',
  'qihuan-shijie-sheding-quanjie': 'https://readdy.ai/api/search-image?query=Anime%20style%20fantasy%20world%20thumbnail%2C%20floating%20islands%2C%20constellations%2C%20magic%20books&width=600&height=350&seq=rel-shijieguan&orientation=landscape',
  'gaojie-zhandou-jiqiao': 'https://readdy.ai/api/search-image?query=Anime%20style%20battle%20thumbnail%2C%20cute%20characters%20fighting%2C%20magic%20effects%2C%20dynamic&width=600&height=350&seq=rel-zhandou&orientation=landscape',
  'an-ying-senlin-mi-mi': 'https://readdy.ai/api/search-image?query=Anime%20style%20dark%20forest%20thumbnail%2C%20glowing%20spirits%2C%20mysterious%2C%20moonlight%20scene&width=600&height=350&seq=rel-anying&orientation=landscape',
  'quan-juese-shou-cang-zhi-nan': 'https://readdy.ai/api/search-image?query=Anime%20style%20cute%20characters%20group%20thumbnail%2C%20diverse%20designs%2C%20colorful%2C%20cheerful&width=600&height=350&seq=rel-jiaose2&orientation=landscape',
  'jingyan-jiasu-shengji-jiqiao': 'https://readdy.ai/api/search-image?query=Anime%20style%20level%20up%20thumbnail%2C%20golden%20aura%2C%20character%20powering%20up%2C%20fantasy&width=600&height=350&seq=rel-shengji&orientation=landscape',
  'huoban-qianghua-jiban-zhinan': 'https://readdy.ai/api/search-image?query=Anime%20style%20friendship%20thumbnail%2C%20cute%20characters%20bonding%2C%20sparkling%20connection%2C%20heartwarming&width=600&height=350&seq=rel-jiban&orientation=landscape',
  'daoju-cangku-guanli-jiqiao': 'https://readdy.ai/api/search-image?query=Anime%20style%20inventory%20thumbnail%2C%20magical%20items%2C%20cozy%20storage%2C%20organized%20fantasy&width=600&height=350&seq=rel-cangku&orientation=landscape',
  'weilai-gengxin-yugao': 'https://readdy.ai/api/search-image?query=Anime%20style%20sky%20castle%20thumbnail%2C%20floating%20in%20clouds%2C%20hopeful%20sunrise&width=600&height=350&seq=rel-gengxin&orientation=landscape',
};

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const article = slug ? getArticleBySlug(slug) : undefined;

  if (!article) {
    return (
      <div className="min-h-screen flex items-center justify-center pt-16">
        <div className="text-center">
          <h1 className="text-2xl font-heading text-foreground-900 mb-4">文章未找到</h1>
          <Link to="/" className="text-primary-600 hover:text-primary-700">返回首页</Link>
        </div>
      </div>
    );
  }

  const relatedArticles = getRelatedArticles(article, 3);

  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.excerpt,
    author: {
      '@type': 'Person',
      name: article.author,
    },
    datePublished: article.date,
    url: `https://chongshengluolidao.com/article/${article.slug}`,
    inLanguage: 'zh-CN',
    isPartOf: {
      '@type': 'WebSite',
      name: '重生萝莉岛',
      url: 'https://chongshengluolidao.com',
    },
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'https://chongshengluolidao.com',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: article.categoryName,
        item: `https://chongshengluolidao.com/category/${article.category}`,
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: article.title,
        item: `https://chongshengluolidao.com/article/${article.slug}`,
      },
    ],
  };

  return (
    <>
      <SEO
        title={`${article.title} | 重生萝莉岛`}
        description={article.excerpt}
        keywords={`重生萝莉岛,${article.tags.join(',')}`}
        canonicalUrl={`https://chongshengluolidao.com/article/${article.slug}`}
        jsonLd={[articleSchema, breadcrumbSchema]}
      />
      <main className="pt-16">
        <Breadcrumb
          items={[
            { label: '首页', path: '/' },
            { label: article.categoryName, path: `/category/${article.category}` },
            { label: article.title },
          ]}
        />

        <article className="w-full px-4 md:px-6 py-8">
          <div className="max-w-4xl mx-auto">
            <div className="relative h-[300px] md:h-[400px] rounded-2xl overflow-hidden mb-8">
              <img
                src={detailImages[article.slug] || detailImages['xinshou-ru-men-gonglue']}
                alt={article.title}
                title={article.title}
                className="w-full h-full object-cover"
              />
            </div>

            <div className="mb-4">
              <Link
                to={`/category/${article.category}`}
                className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs rounded-full font-medium hover:bg-primary-200 transition-colors cursor-pointer"
              >
                {article.categoryName}
              </Link>
            </div>

            <h1 className="font-heading text-2xl md:text-4xl text-foreground-900 mb-4 leading-tight">
              {article.title}
            </h1>

            <div className="flex items-center gap-4 text-sm text-foreground-500 mb-8">
              <span>{article.author}</span>
              <span>·</span>
              <span>{article.date}</span>
              <span>·</span>
              <span>{article.readTime}</span>
            </div>

            <div
              className="prose prose-lg max-w-none text-foreground-800 mb-12
                prose-h2:font-heading prose-h2:text-2xl prose-h2:text-foreground-900 prose-h2:mt-10 prose-h2:mb-4
                prose-h3:font-heading prose-h3:text-xl prose-h3:text-foreground-900 prose-h3:mt-8 prose-h3:mb-3
                prose-p:leading-relaxed prose-p:mb-4
                prose-strong:text-foreground-900
                prose-ul:leading-relaxed prose-ol:leading-relaxed
                prose-li:mb-2"
              dangerouslySetInnerHTML={{ __html: article.content }}
            />

            <div className="flex flex-wrap gap-2 mb-12 pt-8 border-t border-background-200/70">
              {article.tags.map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1 bg-secondary-100 text-secondary-700 text-xs rounded-full font-medium"
                >
                  #{tag}
                </span>
              ))}
            </div>

            {relatedArticles.length > 0 && (
              <section className="pt-8 border-t border-background-200/70">
                <h2 className="font-heading text-2xl text-foreground-900 mb-6">相关推荐</h2>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
                  {relatedArticles.map((rel) => (
                    <Link
                      key={rel.slug}
                      to={`/article/${rel.slug}`}
                      className="group block bg-background-100 rounded-xl overflow-hidden hover:-translate-y-1 transition-all duration-300 cursor-pointer"
                    >
                      <div className="relative h-40 overflow-hidden">
                        <img
                          src={relatedImages[rel.slug] || relatedImages['xinshou-ru-men-gonglue']}
                          alt={rel.title}
                          title={rel.title}
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                          loading="lazy"
                        />
                      </div>
                      <div className="p-4">
                        <h3 className="font-medium text-foreground-900 text-sm mb-1 line-clamp-2 group-hover:text-primary-600 transition-colors">
                          {rel.title}
                        </h3>
                        <span className="text-xs text-foreground-500">{rel.date}</span>
                      </div>
                    </Link>
                  ))}
                </div>
              </section>
            )}
          </div>
        </article>
      </main>
    </>
  );
}